'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Failure = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Failure = exports.Failure = function Failure(_ref) {
  var errorMessage = _ref.errorMessage,
      imageUrl = _ref.imageUrl,
      onModalClose = _ref.onModalClose,
      venueName = _ref.venueName;
  return _react2.default.createElement(
    'div',
    { className: 'reservation reservation--failed' },
    imageUrl && _react2.default.createElement('div', { className: 'modal__header modal__header__img pv++', style: { backgroundImage: 'url("' + imageUrl + '")' } }),
    _react2.default.createElement(
      'div',
      { className: 'reservation__header' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.failed',
        defaultMessage: 'Reservation Failed'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'reservation__venue' },
      venueName
    ),
    errorMessage && _react2.default.createElement(
      'p',
      { className: 'reservation__error-message' },
      errorMessage
    ),
    _react2.default.createElement(
      'button',
      {
        className: 'bt bt--primary bt--lg mb+',
        onClick: onModalClose
      },
      'Done'
    )
  );
};

Failure.propTypes = {
  errorMessage: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string,
  onModalClose: _propTypes2.default.func.isRequired,
  venueName: _propTypes2.default.string.isRequired
};